import {
    OPEN_SW,
    FOCUS_SW,
    CHANGE_SWINDEX,
    OPEN_TOPBTNSW,
    CHANGE_BMAP,
    OPEN_PROB,
    OPEN_EDITER,
    OPEN_HYPERPARAM,
    CHANGE_SHOWCHK,
    SHOW_REGION_MODEL_WINDOW,
    OPEN_EST_BORING,
    SELECT_WATER_SHED,
    CHANGE_SW_POSITION,
    CHANGE_WDATA_CAT,
    SHOW_TESTDATA_WINDOW,
    SHOW_MEATIME_WINDOW,
    SHOW_MEATIME_EDITERWINDOW,
    SHOW_OUTTIME_WINDOW,
    SHOW_INPUTTEMP_WINDOW,
    SHOW_DETAIL_EDITERWINDOW,
} from './actions';

const initData = {
    swCat: null,
    //フォーカスサブウィンドウ(最後の要素が最前面)
    focusSw: ['menu', 'editer', 'prob'],
    swIndex: [],
    topBtnSwCat: null,
    bmap: 'shade',
    probSw: false,
    editerSw: false,
    hyperParamSw: null,
    ds: [],
    swPosition: false,
    wDataCat: null,
    testDataWindowVisible: false,
    outTimeWindowVisible: false,
    inputTmpWindowVisible: false,

};

export function uiReducer(state = initData, action) {
    switch (action.type) {
        case OPEN_SW:
            return openSwReduce(state, action);
        case FOCUS_SW:
            return focusSwReduce(state, action);
        case OPEN_TOPBTNSW:
            return openTopBtnSwReduce(state, action);
        case CHANGE_BMAP:
            return changeBmapReduce(state, action);
        case OPEN_PROB:
            return openProbReduce(state, action);
        case OPEN_EDITER:
            return openEditerReduce(state, action);
        case OPEN_HYPERPARAM:
            return openHyperParamReduce(state, action);
        case SHOW_REGION_MODEL_WINDOW:
            return showRegionModelWindowReduce(state, action);
        case OPEN_EST_BORING:
            return openEstBoringReduce(state, action);
        case SELECT_WATER_SHED:
            return selectWaterShedReduce(state, action);
        case CHANGE_SW_POSITION:
            return changeSwPosiReduce(state, action);
        case CHANGE_WDATA_CAT:
            return changewDataSwReduce(state, action);
        case SHOW_TESTDATA_WINDOW:
            return showTestDataWindowReduce(state, action);
        case SHOW_MEATIME_WINDOW:
            return showMeaTimeWindowReduce(state, action);
        case SHOW_MEATIME_EDITERWINDOW:
            return showMeaTimeEditerWindowReduce(state, action);
        case SHOW_OUTTIME_WINDOW:
            return showOutTimeWindowReduce(state, action);
        case SHOW_INPUTTEMP_WINDOW:
            return showInputTempWindowReduce(state, action);
        case SHOW_DETAIL_EDITERWINDOW:
            return showDetailEditerWindowReduce(state, action);
        default:
            return state;
    }
}

export function openSwReduce(state, action) {
    return {
        ...state,
        swCat: action.value
    };
}

export function focusSwReduce(state, action) {
    return {
        ...state,
        focusSw: action.focusSw
    };
}

export function openTopBtnSwReduce(state, action) {
    return {
        ...state,
        topBtnSwCat: action.value
    };
}

export function changeBmapReduce(state, action) {
    return {
        ...state,
        bmap: action.bmap
    };
}

export function openProbReduce(state, action) {
    return {
        ...state,
        probSw: action.isOpen
    };
}

export function openEditerReduce(state, action) {
    return {
        ...state,
        editerSw: action.id !== null ? true : false
    };
}

export function openHyperParamReduce(state, action) {
    return {
        ...state,
        hyperParamSw: action.mode
    };
}

export function showRegionModelWindowReduce(state, action) {
    return {
        ...state,
        regionModelWindowVisible: action.isVisible
    };
}

export function openEstBoringReduce(state, action) {
    return {
        ...state,
        estBorSw: action.id !== null ? true : false
    };
}

export function selectWaterShedReduce(state, action) {
    return {
        ...state,
        waterShedSelectable: action.isSelectable
    };
}

export function changeSwPosiReduce(state, action) {
    return {
        ...state,
        swPosition: action.value
    };
}

export function changewDataSwReduce(state, action) {
    return {
        ...state,
        wDataCat: action.value
    };
}

export function showTestDataWindowReduce(state, action) {
    return {
        ...state,
        testDataWindowVisible: action.isVisible
    };
}

export function showMeaTimeWindowReduce(state, action) {
    return {
        ...state,
        meaTimeWindowVisible: action.isVisible
    };
}

export function showMeaTimeEditerWindowReduce(state, action) {
    return {
        ...state,
        meaTimeEditerWindowVisible: action.isVisible
    };
}

export function showOutTimeWindowReduce(state, action) {
    return {
        ...state,
        outTimeWindowVisible: action.isVisible
    };
}

export function showInputTempWindowReduce(state, action) {
    return {
        ...state,
        inputTenpWindowVisible: action.isVisible
    };
}

export function showDetailEditerWindowReduce(state, action) {
    return {
        ...state,
        detailEditerWindowVisible: action.isVisible
    };
}